/* Used by Storefront */
import React from "react";
import VisibleHiddenText from "./VisibleHiddenText";
interface Props {
  headline: string;
  visibleText: string;
  hideHiddenText: boolean;
  overflowText?: string;
  visibleMarkup?: string;
}
const SideBarVisibleHiddenText = ({
  headline,
  visibleText,
  hideHiddenText,
  overflowText,
  visibleMarkup
}: Props) => {
  const hasHeadline = headline?.length > 0 && visibleText?.length > 0;
  return <>
      {hasHeadline && <h2 className="page-header-2">{headline}</h2>}

      <VisibleHiddenText visibleText={visibleText} hideHiddenText={hideHiddenText} overflowText={overflowText} visibleMarkup={visibleMarkup} data-sentry-element="VisibleHiddenText" data-sentry-source-file="SideBarVisibleHiddenText.tsx" />
    </>;
};
export default SideBarVisibleHiddenText;